import PaulaHeadshot from "../Media/PaulaHeadshot.png";
import CindyHeadshot from "../Media/CindyHeadshot.png";

export const ResearchProjectBoard = [
  {
    id: "paula",
    name: "Paula",
    image: PaulaHeadshot,
    description: "2nd year",
    major: "Civil & Env. Engineering",
  },
  {
    id: "cindy",
    name: "Cindy",
    image: CindyHeadshot,
    description: "4th year",
    major: "Aerospace Engineering",
  },
];